import React from 'react';

import RangePicker from 'react-daterange-picker';

import DatePickerPaginationArrow from './DatePickerPaginationArrow';

import OFS_I18N from 'ofs/i18n';

var gettext = OFS_I18N.gettext;

var messages = {
  SELECTED_LABEL: gettext("Your selected dates")
};

var DatePicker = React.createClass({
  render() {
    return (
      <RangePicker
        bemNamespace="ofs"
        bemBlock="DatePicker"
        firstOfWeek={1}
        paginationArrowComponent={DatePickerPaginationArrow}
        selectedLabel={messages.SELECTED_LABEL}
        {...this.props} />
    );
  }
});

export default DatePicker;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/datepicker/DatePicker.jsx
 **/